
import $ from 'jquery';

import {validInputNumber} from './../general/Validation.js';
import {showError,hideError} from './../general/Error.js';

// PACKSTATION
$(document).ready( function() {
    $(document).on('change',
        '[id^=register_invoice_2_deliverypackingstation]',
        function (ev) {
            if ( $( this ).is( ':checked' ) ) {
                $( this ).closest( 'form' ).find( '.acl_input--country' ).val( 'a7c40f631fc920687.20179984' );
            }
        });
    $('[id^=register_invoice_2_packstation_number]', document)
        .keypress(function (e) {
            if (e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57)) {
                return false;
            }
        })
        .change(function () {
            var val = ($(this).val() || '').trim(),
                form = $(this).closest('form').find("[id^=form_section_register_invoice_2_type_packingstation]");
            if (!validInputNumber(val)) {
                return form.addClass('row_has_message').addClass('has_error');
            }
            form.removeClass('row_has_message').removeClass('has_error');
            form.find('[name="deladr[oxaddress__packstation]"]').val(['Packstation', val].join(' '))
        });

    $(document).on( 'change', '.acl_input--country', function( ev ) {

        // Get Form.
        const $form = $( this ).closest( 'form' );

        // Check if the value equals to Packstation.
        const isPackstation = $( this ).val() === 'a7c40f631fc920687.20179984';

        if ( ! isPackstation ) {
            // Set Deliverstation fields false.
            $form.find('[id^=register_invoice_2_deliverypackingstation]').prop( 'checked', false );
            $form.find('.r_packstation').removeClass('active').hide();

            // Activate Section.
            $form.find('#form_section_register_invoice_2_type_address');
            $form.find('[id^=form_section_register_invoice_2_type_address]').addClass('active').show();

            // Enable Address Fields.
            $form.find( '.acl_input--street_name' ).prop( 'disabled', false );
            $form.find( '.acl_input--street_number' ).prop( 'disabled', false );
            $form.find( '.acl_input--street_and_number' ).prop( 'disabled', false );

        } else if ( isPackstation && $( '#register_invoice_2_deliverypackingstation:checked' ).length > 1 ) {

            // Disable Address Fields.
            $form.find( '.acl_input--street_name' ).prop( 'disabled', true );
            $form.find( '.acl_input--street_number' ).prop( 'disabled', true );
            $form.find( '.acl_input--street_and_number' ).prop( 'disabled', true );
        }
    });


    if ( $('.articleOutOfStock').length > 0 ) {
        $('html, body').animate({
            scrollTop: ( $('.articleOutOfStock').first().offset().top - 200 )
        }, 500);
    }

    $( '.acl_input--street_and_number' ).on( 'input change focusout validatelement.acl', function() {

        const $inputRow = $( this ).closest( '.input_row' );

        const street = $( this ).val();
        const number = street.match( /[0-9](.*)/gm );

        let streetname = street.trim();
        let numberval = '';

        if ( number && number.length > 0 ) {
            streetname = street.replace( number[0], '' ).trim();
            numberval = number[0];
        } else {

            this.setCustomValidity( 'Bitte geben Sie eine Hausnummer an' );
            return true;
        }

        $( '.acl_input--street_name', $inputRow ).val( streetname );
        $( '.acl_input--street_number', $inputRow ).val( numberval );

        if ( streetname && streetname.length > 35 ) {

            this.dataset.displayValidation = true;
            this.setCustomValidity( 'Der Straßenname darf nicht länger als 35 Zeichen sein' );

            return false;
        } else {

            // Hide Error, if input is valid.
            if ( this.checkValidity() ) {
                hideError( $( this ) );
                return true;
            }
        }

    }).ready( function() {

        $( '.acl_input--street_and_number' ).each( function() {
            $( this ).val( $( this ).val().trim() );
        } );
    });

    $('.numberinput').keydown(function (e) {
        // Allow: backspace, delete, tab, escape, enter and .
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    });

    $('#register_form button,#userform button').click(function (event) {
        setTimeout(function () {
            var sections = $('.has_error,.has_warning,.zip_error').find('input').not(':disabled').closest('section');
            if (sections.length > 0) {
                $('html, body').animate({
                    scrollTop: (sections.first().offset().top - 50)
                }, 500);
            }
        }, 10);

    });

    $('#register_form2 button').click(function (event) {
        setTimeout(function () {
            var sections = $('.has_error,.has_warning,.zip_error').closest('.input_row').find('.input_row_message').not(':disabled');
            if (sections.length > 0) {
                $('html, body').animate({
                    scrollTop: (sections.first().offset().top - 50)
                }, 500);
            }
        }, 10);

    });
});
